import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { PartnerAdvertiser } from 'src/app/models/sidebar-widgets.model';
import { SidebarWidgetsService } from 'src/app/services/sidebar-widgets.service';

// « Nos partenaires » : logos des annonceurs partenaires (isPartner, suivi d'Awin chaque nuit),
// ceux qui ont le plus de deals en ligne d'abord ; chaque logo ouvre la page des deals du marchand
@Component({
    selector: 'app-partners-sidebar',
    templateUrl: './partners-sidebar.component.html',
    styleUrls: ['./partners-sidebar.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PartnersSidebarComponent implements OnInit {

  partners: PartnerAdvertiser[] = [];

  constructor(private widgets: SidebarWidgetsService) { }

  ngOnInit(): void {
    this.widgets.partners().subscribe(partners => this.partners = partners || []);
  }
}
